import { useEffect, useState } from 'react'

// The menu tile already loaded imageUrl (256), so the modal shows it at once and swaps to
// imageUrlLarge (800) only once that has fully loaded — the band never sits empty while
// 130–800 KB arrive. null means: show the placeholder.
export const useModalImageSource = (
  imageUrl: string | null | undefined,
  imageUrlLarge: string | null | undefined
) => {
  const [src, setSrc] = useState<string | null>(
    imageUrl || imageUrlLarge || null
  )

  useEffect(() => {
    setSrc(imageUrl || imageUrlLarge || null)
    if (!imageUrl || !imageUrlLarge) return undefined

    let active = true
    const preload = new Image()
    preload.onload = () => {
      if (active) setSrc(imageUrlLarge)
    }
    preload.src = imageUrlLarge
    return () => {
      active = false
      preload.onload = null
    }
  }, [imageUrl, imageUrlLarge])

  const onError = () =>
    setSrc((current) =>
      current === imageUrl && imageUrlLarge ? imageUrlLarge : null
    )

  return { src, onError }
}
